import PropTypes from 'prop-types';
import React from 'react';
import { Record } from 'immutable';

import t from '../../lib/I18n';

import ValidatedField from '../form/ValidatedField';


export default function CustomerEmail (props) {
    // Translated here, not in defaultProps, because the brand is not in config yet when this module loads
    const label = props.label === undefined ? t('customerdetails.confirmemail') : props.label;
    const placeholder = props.placeholder === undefined ? t('customerdetails.email') : props.placeholder;

    return (
        <ValidatedField type="email"
                        id={ props.field }
                        data-test-id="customer-email-input"
                        labelClassName="sr-only"
                        standalone
                        { ...props }
                        label={ label }
                        placeholder={ placeholder } />
    );
}


CustomerEmail.propTypes = {
    field: PropTypes.string.isRequired,
    form: PropTypes.instanceOf(Record).isRequired,
    label: PropTypes.any,
    placeholder: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    validation: PropTypes.object,
    visited: PropTypes.bool,
    disabled: PropTypes.bool,
    required: PropTypes.bool
};

CustomerEmail.defaultProps = {
    field: 'email',
    validation: null,
    visited: false,
    disabled: false,
    required: true
};
